import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetFanLetterByIdResponse =
  paths['/api/v1/fan_letters/{id}']['get']['responses'][200]['content']['application/json']['fanLetter'];

export type GenerateFanLetterResponse =
  paths['/api/v1/fan_letters/{id}/generate']['post']['responses'][200]['content']['application/json'];

export type GetFanLettersResponse =
  paths['/api/v1/fan_letters']['get']['responses'][200]['content']['application/json']['fanLetters'];

export type GetFanLettersQuery = paths['/api/v1/fan_letters']['get']['parameters']['query'];

export async function getFanLetterById({ id }: { id: string }): Promise<GetFanLetterByIdResponse> {
  const { data, error } = await client.GET('/api/v1/fan_letters/{id}', {
    headers: authHeaders(),
    params: {
      path: {
        id: id
      }
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting fan letter by id');
  return data.fanLetter;
}

export async function generateFanLetter({
  id
}: {
  id: string;
}): Promise<GenerateFanLetterResponse> {
  const { data, error } = await client.POST('/api/v1/fan_letters/{id}/generate', {
    headers: authHeaders(),
    params: {
      path: {
        id: id
      }
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when reading fan letter');
  return data;
}

export async function getFanLetters({
  query
}: {
  query: GetFanLettersQuery;
}): Promise<GetFanLettersResponse> {
  const { data, error } = await client.GET('/api/v1/fan_letters', {
    headers: authHeaders(),
    params: {
      query: {
        ...query
      }
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting fan letters');
  return data.fanLetters;
}